import type { AxiosError } from 'axios';
import type { CreatorPayout } from 'backend';
import { createQuery } from 'react-query-kit';

import { supabase } from '../../supabase-client';

type Response = CreatorPayout[];
type Variables = { uid?: string };

export const usePayouts = createQuery<Response, Variables, AxiosError>({
  queryKey: ['payouts'],
  fetcher: async ({ uid } = {}) => {
    if (!uid) {
      const {
        data: { user },
      } = await supabase.auth.getUser();
      if (!user) throw new Error('Not authenticated');
      uid = user.id;
    }

    const { data, error } = await supabase
      .from('creatorPayouts')
      .select('*')
      .eq('uid', uid);
    if (error) throw error;
    return data;
  },
});
